export default "__VITE_ASSET__BJpwlnXG__"